<template>
  <div class="intro-body">
    <div ref="alertContainer" class="page-status-alerts"></div>
    <Intro-start v-if="getPages.length == 0 && isPagesLoaded"></Intro-start>
    <Intro-main v-if="getPages.length && isPagesLoaded"></Intro-main>
    <loading :active="!isPagesLoaded" :is-full-page="false"></loading>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

import IntroStart from "./Intro-start";
import IntroList from "./Intro-list";
import IntroMain from "./Intro-main";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Intro-body",
  components: {
    IntroStart,
    Loading,
    IntroList,
    IntroMain,
  },
  computed: {
    ...mapGetters([
      "isBySocial",
      "getPeriod",
      "getPages",
      "getAllowedAccesses",
      "getProfile",
      "getAddedHashes",
      "getSelectedPages",
      "isPagesLoaded",
      "getDisabledDates",
      "getPagesByAccessVisible",
      "getPagesBySocial",
      "getSelectedAccessAcount",
      "isAddPageVisible",
      "isAccessManagerVisible",
    ]),
    
    // Check for pages with "paused" status belonging to other users
    hasPausedPages() {
      if (!this.getProfile || !this.getPages.length) return false;
      return this.getPages.some(page => 
        (page.status === 'paused' || page.owner_plan_active === false) && 
        page.email !== this.getProfile.email
      );
    },
    
    // Check for pages with "error" status and need_token_change = 1
    hasTokenErrorPages() {
      if (!this.getPages.length) return false;
      return this.getPages.some(page => 
        page.status === 'error' && 
        page.need_token_change === 1
      );
    },
    
    // Check for pages with "token-error" status
    hasTokenErrorStatusPages() {
      if (!this.getPages.length) return false;
      return this.getPages.some(page => 
        page.status === 'token-error'
      );
    }
  },
  data() {
    return {
      shownAlerts: {
        paused: false,
        tokenError: false,
        tokenErrorStatus: false
      }
    };
  },
  watch: {
    // Watch for changes in page data to show alerts
    hasPausedPages(newVal) {
      if (newVal && !this.shownAlerts.paused) {
        this.showPausedPagesAlert();
        this.shownAlerts.paused = true;
      } else if (!newVal) {
        this.shownAlerts.paused = false;
      }
    },
    
    hasTokenErrorPages(newVal) {
      if (newVal && !this.shownAlerts.tokenError) {
        this.showTokenErrorAlert();
        this.shownAlerts.tokenError = true;
      } else if (!newVal) {
        this.shownAlerts.tokenError = false;
      }
    },
    
    hasTokenErrorStatusPages(newVal) {
      if (newVal && !this.shownAlerts.tokenErrorStatus) {
        this.showTokenErrorStatusAlert();
        this.shownAlerts.tokenErrorStatus = true;
      } else if (!newVal) {
        this.shownAlerts.tokenErrorStatus = false;
      }
    }
  },
  methods: {
    showPausedPagesAlert() {
      if (localStorage.getItem('pausedPagesAlertDismissed') === '1') return;
      const alertInstance = this.$alert.show({
        message: this.$t('PAGE_STATUS_PAUSED_ALERT', {}, 'Some pages were paused due to the end of their owner\'s subscription plan'),
        type: 'inline',
        color: '',
        component: this,
        target: this.$refs.alertContainer,
        duration: 0 // Keep alert visible until manually closed
      });
      if (alertInstance) {
        alertInstance.$on('closed', () => {
          localStorage.setItem('pausedPagesAlertDismissed', '1');
        });
      }
    },
    
    showTokenErrorAlert() {
      this.$alert.show({
        message: this.$t('PAGE_STATUS_TOKEN_ERROR_ALERT', {}, 'Some pages require token refresh due to authentication issues'),
        type: 'inline',
        color: 'red',
        component: this,
        target: this.$refs.alertContainer,
        duration: 0
      });
    },
    
    showTokenErrorStatusAlert() {
      this.$alert.show({
        message: this.$t('PAGE_STATUS_TOKEN_ERROR_STATUS_ALERT', {}, 'Your access token for some pages is not valid. Relogin in the app using needed socials to continue collecting data'),
        type: 'inline',
        color: 'red',
        component: this,
        target: this.$refs.alertContainer,
        duration: 0
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.hasPausedPages) {
        this.showPausedPagesAlert();
        this.shownAlerts.paused = true;
      }
      
      if (this.hasTokenErrorPages) {
        this.showTokenErrorAlert();
        this.shownAlerts.tokenError = true;
      }
      
      if (this.hasTokenErrorStatusPages) {
        this.showTokenErrorStatusAlert();
        this.shownAlerts.tokenErrorStatus = true;
      }
    });
  },
};
</script>
